module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-form pure-form"
  }, [_c('div', {
    staticClass: "f-input"
  }, [(_vm.needName) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyName),
      expression: "keyName"
    }],
    staticClass: "f-input-m",
    attrs: {
      "type": "text",
      "placeholder": "key/name"
    },
    domProps: {
      "value": (_vm.keyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyName = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.required
    }
  }), _vm._v(" 必填项\n    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formatSelected),
      expression: "formatSelected"
    }],
    staticClass: "f-input-m",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.formatSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.formats), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item
      }
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")])
  }), 0), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.formatSelected !== 'array' && _vm.formatSelected !== 'object') ? [(_vm.formatSelected === 'string') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valName),
      expression: "valName"
    }],
    staticClass: "f-input-m",
    attrs: {
      "type": "text",
      "placeholder": "默认值"
    },
    domProps: {
      "value": (_vm.valName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valName = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formatSelected === 'int') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valName),
      expression: "valName"
    }],
    staticClass: "f-input-m",
    attrs: {
      "type": "number",
      "placeholder": "默认值"
    },
    domProps: {
      "value": (_vm.valName)
    },
    on: {
      "change": _vm.dealNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valName = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formatSelected === 'boolean') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valName),
      expression: "valName"
    }],
    staticClass: "f-input-m",
    attrs: {
      "name": "value"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.valName = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.dealBoolean]
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": true
    }
  }, [_vm._v("true")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("false")])]) : _vm._e(), _vm._v(" "), (_vm.formatSelected === 'unicode') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valName),
      expression: "valName"
    }],
    staticClass: "f-input-m",
    attrs: {
      "type": "text",
      "placeholder": "默认值"
    },
    domProps: {
      "value": (_vm.valName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valName = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formatSelected === 'datetime') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valName),
      expression: "valName"
    }],
    staticClass: "f-input-m",
    attrs: {
      "type": "text",
      "placeholder": "默认值",
      "onfocus": "(this.type='date')",
      "onblur": "(this.type='text')"
    },
    domProps: {
      "value": (_vm.valName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valName = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.desc),
      expression: "desc"
    }],
    staticClass: "f-input-m",
    attrs: {
      "type": "text",
      "placeholder": "描述"
    },
    domProps: {
      "value": (_vm.desc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.desc = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formatSelected !== 'boolean') ? [(_vm.formatSelected === 'datetime') ? [(_vm.formatSelected === 'datetime') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.range[0]),
      expression: "range[0]"
    }],
    staticClass: "f-input-m",
    attrs: {
      "type": "text",
      "placeholder": "范围",
      "onfocus": "(this.type='date')",
      "onblur": "(this.type='text')"
    },
    domProps: {
      "value": (_vm.range[0])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.range, 0, $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" -\n          "), (_vm.formatSelected === 'datetime') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.range[1]),
      expression: "range[1]"
    }],
    staticClass: "f-input-m",
    attrs: {
      "type": "date",
      "min": _vm.range[0]
    },
    domProps: {
      "value": (_vm.range[1])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.range, 1, $event.target.value)
      }
    }
  }) : _vm._e()] : [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.re),
      expression: "re"
    }],
    staticClass: "f-input-m",
    attrs: {
      "type": "text",
      "placeholder": '正则' + _vm.reDefault[_vm.formatSelected]
    },
    domProps: {
      "value": (_vm.re)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.re = $event.target.value
      }
    }
  })]] : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "f-btns"
  }, [_c('button', {
    staticClass: "pure-button f-confirm",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("\n      " + _vm._s(this.formBtnText.confirmText) + "\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "pure-button",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n      " + _vm._s(this.formBtnText.cancelText) + "\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "f-input-m"
  }, [_c('b', [_vm._v(":")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-68a7278d!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/template/ItemAddForm.vue
// module id = T4k1
// module chunks = 4